import { render } from "./PhoneCodePicker.vue?vue&type=template&id=348e58e0&ts=true"
import script from "./PhoneCodePicker.vue?vue&type=script&lang=ts"
export * from "./PhoneCodePicker.vue?vue&type=script&lang=ts"

import "./PhoneCodePicker.vue?vue&type=style&index=0&id=348e58e0&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__